export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

//common actions
export const SET_ONGOING_EDIT_GLOBALLY = "SET ONGOING EDIT GLOBALLY";
export const MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION = "EXPAND IMAGE";
export const REMOVE_ALL_PERSISTED_DATA = "REMOVE ALL PERSISTED DATA";

//bearing actions
export const ADD_NEW_BEARING = "ADD NEW BEARING";
export const REMOVE_BEARING = "REMOVE BEARING";

//customer actions
export const FETCH_ALL_CUSTOMER = 'FETCH_ALL_CUSTOMER';
export const CUSTOMER_LOADING = 'CUSTOMER_LOADING';
export const JWT_EXPIRED = "JWT EXPIRED";

//profile actions
export const SET_PROFILES = "SET PROFILES";
export const SET_SELECTED_PROFILE = "SET_SELECTED_PROFILE";
export const UPDATE_PROFILE_HOOK = "UPDATE_PROFILE_HOOK";
export const UPDATE_PROFILE_ACCESS_STATUS = "UPDATE_PROFILE_ACCESS_STATUS";
export const ADD_IMPORTED_PROFILE = "ADD IMPORTED PROFILE";
export const SET_PROFILE_ACCESSIBILITY = "SET PROFILE ACCESSIBILITY";

//equipment actions
export const DESELECT_EQUIPMENT = "REMOVE SELECTED EQUIPMENT";
export const SET_ALL_EQUIPMENTS_AND_PROFILE_ACCESSIBILITY = "SET ALL EQUIPMENTS AND PROFILE ACCESSIBILITY";
export const SET_EQUIPMENT_DETAIL_LOADING = "SET EQUIPMENT DETAIL LOADING";
export const UPDATE_EQUIPMENT_INFORMATION = "UPDATE EQUIPMENT INFORMATION";
export const ROTATE_EQUIPMENT_IMAGE = "ROTATE EQUIPMENT IMAGE";
export const ADD_CLONED_EQUIPMENT = "ADD CLONED EQUIPMENT";
export const SET_EQUIPMENTS = "SET EQUIPMENT UNITS";
export const UPDATE_EQUIPMENT_LOCATION = "UPDATE EQUIPMENT LOCATION";

//component actions
export const SET_SELECTED_COMPONENT_ID = "SET SELECTED COMPONENT ID";
export const SET_SELECTED_COMPONENT_DETAILS = "SET SELECTED COMPONENT DETAILS";
export const DESELECT_COMPONENT = "REMOVE SELECTED COMPONENT";
export const UPDATE_COMPONENT_INFORMATION = "UPDATE COMPONENT INFORMATION";
export const ROTATE_COMPONENT_IMAGE = "ROTATE COMPONENT IMAGE";
export const SET_COMPONENT_LOADING = "SET COMPONENT LOADING";
export const UPDATE_COMPONENT_NAME = "UPDATE COMPONENT NAME"

//equipment unit actions
export const UPDATE_EQUIPMENT_UNIT_FOUNDATION = "UPDATE EQUIPMENT UNIT FOUNDATION";
export const UPDATE_EQUIPMENT_UNIT_CLASS = "UPDATE EQUIPMENT UNIT CLASS";
export const SET_EQUIPMENT_UNIT_CLASSES_LIST = "SET EQUIPMENT UNIT CLASSES LIST";
export const UPDATE_EQUIPMENT_UNIT_NAME = "UPDATE EQUIPMENT UNIT NAME";
export const UPDATE_EQUIPMENT_UNIT_POSITIVE_DISPLACEMENT = "UPDATE EQUIPMENT UNIT POSITIVE DISPLACEMENT";

//sensor actions
export const ADD_NEW_SENSOR = "ADD NEW SENSOR";
export const UPDATE_SENSOR_INFORMATION = "UPDATE SENSOR INFORMATION";
export const REMOVE_DETACHED_SENSOR = "REMOVE DETACHED SENSOR";

//category actions
export const SET_CATEGORIES = "SET CATEGORIES";
export const SELECT_OR_DESELECT_CATEGORY = "SELECT OR DESELECT CATEGORY";
export const SET_NEW_CATEGORY_ADD_FLAG = "SET ADD STATUS";
export const SET_CATEGORY_JSON = "SET CATEGORY JSON";
export const APPEND_NEWLY_ADDED_CATEGORY = "APPEND NEWLY ADDED CATEGORY";
export const DELETE_CATEGORY = "DELETE CATEGORY";
export const SET_CATEGORY_IN_EDIT = "SET CATEGORY IN EDIT";
export const CANCEL_CATEGORY_EDIT = "CANCEL CATEGORY EDIT";
export const UPDATE_CATEGORY = "UPDATE CATEGORY";
export const CLEAR_PERSISTED_CATEGORY_DATA = "CLEAR PERSISTED CATEGORY DATA";
export const SET_JSON_FROM_SELECTED_GLOBAL_CATEGROY = "SET JSON FROM SELECTED GLOBAL CATEGROY";
export const UPDATE_CATEGORY_INFO = "UPDATE CATEGORY RELATED INFORMATION AFTER APPLYING";
export const REMOVE_CATEGORY_FROM_EQUIPMENT_UNIT = "REMOVE CATEGORY FROM EQUIPMENT UNIT";